import React from 'react'
import { TextInput } from '@tecuity/granite-ui/TextInput'
import { Checkbox } from '@tecuity/granite-ui/Checkbox'
import { SelectBox } from '@tecuity/granite-ui/SelectBox'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'

const MiscRecordDetailFieldDrawerContent = ({
  field,
  cards,
  onLabelChange,
  onIsEnabledChange,
  onCardChange,
  onDeleteClick,
}) => {
  const cardOptions = cards.map((c, i) => ({ value: c.CardId, label: c.Label || `Card ${i + 1}` }))

  return (
    <div className="misc-record-detail-field-drawer-content">
      <TextInput
        label="Label"
        value={field.Label}
        onChange={(e) => onLabelChange(e.target.value)}
      />
      <Checkbox
        label="Is Enabled"
        checked={!!field.IsEnabled}
        onChange={(val) => onIsEnabledChange(val)}
      />
      <SelectBox
        label="Card"
        value={field.CardId ?? ''}
        onChange={(val) => onCardChange(val)}
        options={cardOptions}
      />
      <ContextButton variant="danger" onClick={onDeleteClick} disabled={field.CardId == null}>
        Delete Field
      </ContextButton>
    </div>
  )
}

export default MiscRecordDetailFieldDrawerContent
